// extracted by mini-css-extract-plugin
export default {"CusImg":"Testimonial_CusImg__wvaoU","span":"Testimonial_span__Dwh0p","cusDet":"Testimonial_cusDet__JoOEL","text":"Testimonial_text__Eu6+l"};